import { ArrowRight } from '@icons';
import React from 'react';
import { Link } from 'react-router-dom';

interface NewBrandBannerProps {}

const NewBrandBanner: React.FC<NewBrandBannerProps> = () => {
	return (
		<div
			style={{
				backgroundColor: 'var(--np-primary-color--bg)',
				padding: '1rem',
				borderRadius: '12px',
				display: 'grid',
				gap: '1rem',
				maxWidth: '440px',
				margin: '0 auto',
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '1rem',
				}}
			>
				<span
					style={{
						fontSize: '30px',
					}}
				>
					🔔
				</span>
				<span
					style={{
						fontWeight: 700,
					}}
				>
					Novità: OpenRep diventa Sonar!
				</span>
			</div>
			<span>
				Cambia il nome, non la missione: offrire una esperienza di gestione dei fondi pubblici sempre più completa, integrata, efficace ed
				efficiente.
			</span>
			<div
				style={{
					marginLeft: 'auto',
				}}
			>
				<Link
					to="#new-brand"
					className="btn custom-ghost-button"
					style={{
						color: 'var(--np-primary-color)',
						textTransform: 'none',
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
					}}
				>
					scopri di più <ArrowRight fill="var(--np-primary-color)" />
				</Link>
			</div>
		</div>
	);
};

export default NewBrandBanner;
